const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Shipping+Address+on+Profile+API


function updateShippingAddress(addressData) {
    const url = '/api/users/profiles/address';
    return ufeApi.makeRequest(url, {
        method: 'PUT',
        body: JSON.stringify(addressData)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = updateShippingAddress;
